module.exports = "<router-outlet></router-outlet>\n<app-spinner *ngIf=\"!showSpin\"></app-spinner>\n"


//////////////////
// WEBPACK FOOTER
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main